import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BsSearch } from "react-icons/bs";
import CreateVaccinationModal from '../Popup/CreateVaccinationModal';
import VaccinationFilter from '../Buttons/VaccinationFilter';
import ActionButton from '../Buttons/VaccinationActionButton';
import UniversalSearch from '../Buttons/UniversalSearch';

const VaccinationFiltersHeader = ({ 
  onFilterChange,
  onSearchChange,
  selectedVaccinations = [],
  onClearSelection,
  onBulkDelete = () => {} 
}) => {
  const [currentFilters, setCurrentFilters] = useState({
    id: '',
    patientId: '',
    patientName: '',
    vaccineName: '',
    vaccineType: '',
    manufacturer: '',
    batchNumber: '',
    expirationDate: '',
    administrationDate: '',
    administeredBy: '',
    administrationSite: '',
    dosage: '',
    route: '',
    nextDueDate: '',
    vaccinationStatus: '',
    adverseReactions: '',
    notes: '',
    searchName: '',
    status: ''
  });
  const [activeFilters, setActiveFilters] = useState([]);
  const [showActiveFilters, setShowActiveFilters] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showFilterSidebar, setShowFilterSidebar] = useState(false);

  const convertFiltersToArray = (filters) => {
    return Object.entries(filters)
      .filter(([, value]) => value !== '')
      .map(([label, value]) => ({ 
        label: label.charAt(0).toUpperCase() + label.slice(1), 
        value, 
        key: label 
      }));
  };

  const handleFilterChange = (filters) => {
    setCurrentFilters(filters);
    
    const newActiveFilters = convertFiltersToArray(filters);
    setActiveFilters(newActiveFilters);
    
    onFilterChange(filters);
  };

  const handleUniversalSearch = (searchTerm) => {
    const updatedFilters = { 
      ...currentFilters, 
      searchName: searchTerm 
    };
    
    setCurrentFilters(updatedFilters);
    
    const newActiveFilters = convertFiltersToArray(updatedFilters);
    setActiveFilters(newActiveFilters);

    onSearchChange(searchTerm);
  };

  const removeFilter = (filterToRemove) => {
    const updatedFilters = { ...currentFilters };
    
    updatedFilters[filterToRemove.key] = '';
    
    setCurrentFilters(updatedFilters);
    
    const newActiveFilters = convertFiltersToArray(updatedFilters);
    setActiveFilters(newActiveFilters);
    
    onFilterChange(updatedFilters);
  };

  const clearAllFilters = () => {
    const resetFilters = {
      id: '',
      patientId: '',
      patientName: '',
      vaccineName: '',
      vaccineType: '',
      manufacturer: '',
      batchNumber: '',
      expirationDate: '',
      administrationDate: '',
      administeredBy: '',
      administrationSite: '',
      dosage: '',
      route: '',
      nextDueDate: '',
      vaccinationStatus: '',
      adverseReactions: '',
      notes: '',
      searchName: '',
      status: ''
    };

    setCurrentFilters(resetFilters);
    setActiveFilters([]);
    onFilterChange(resetFilters);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSaveVaccination = (vaccinationData) => {
    console.log('Vaccination Data:', vaccinationData);
  };

  const toggleActiveFiltersVisibility = () => {
    setShowActiveFilters(!showActiveFilters);
  };

  const toggleFilterSidebar = () => {
    setShowFilterSidebar(!showFilterSidebar);
  };

  // Include selected vaccinations in active filters
  const allActiveFilters = [
    ...activeFilters,
    ...(selectedVaccinations.length > 0 
      ? [{ 
          label: 'Vacc. Selected', 
          value: selectedVaccinations.length, 
          key: 'selectedVaccinations' 
        }] 
      : [])
  ];

  return (
    <>     
      <div className="filter-container py-3">
        <div className="row align-items-center">
          <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
            <UniversalSearch 
              onSearch={handleUniversalSearch}
              placeholder="Search vaccinations..."
            />
          </div>

          <div className="col-md-7 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2 gy-3 flex-wrap">
              <ActionButton 
                selectedVaccinations={selectedVaccinations}
                onBulkDelete={onBulkDelete}
              />

            
              {/* Filter button */}
              <Link 
                to="#" 
                className="btn btn-gray filterbtn d-flex align-items-center gap-1 position-relative"
                type="button"
                onClick={toggleFilterSidebar}
              >
                <div className="filter_text d-flex align-items-center gap-1">
                  <span className="d-block material-symbols-outlined icon-md">tune</span>
                  <span className="d-block">Filter</span>
                </div>
                {/* Show badge only if there are active filters */}
                {allActiveFilters.length > 0 && (
                  <span 
                    className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-primary" 
                    style={{fontSize: '0.6rem', padding: '0.2rem 0.4rem'}}
                  >
                    {allActiveFilters.length}
                  </span>
                )}
              </Link>
            

            <CreateVaccinationModal 
              show={showModal}
              handleClose={handleCloseModal}
              onSave={handleSaveVaccination}
            />
          </div>
        </div>
      </div>

      {showFilterSidebar && (
        <div 
          className="position-fixed top-0 end-0 h-100 bg-white shadow" 
          style={{width: '350px', zIndex: 1050, overflowY: 'auto'}}
        >
          <div className="p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Filters of Vaccinations</h5>
              <button 
                className="btn btn-close" 
                onClick={toggleFilterSidebar}
              ></button>
            </div>
            <VaccinationFilter 
              initialFilters={currentFilters}
              onFilterChange={handleFilterChange} 
            />
          </div>
        </div>
      )}
      {showActiveFilters && allActiveFilters.length > 0 && (
        <div className="container-fluid mb-3 mt-3 border ">
          <div className="row align-items-center">
            <div className="col-auto">
              <span className="text-muted me-2">Active Filters:</span>
              {allActiveFilters.map((filter, index) => (
                <span 
                  key={index} 
                  className="badge bg-light text-dark me-2 d-inline-flex align-items-center"
                >
                  {filter.label}: {filter.value}
                  <button 
                    className="btn btn-sm btn-link p-0 ms-2"
                    onClick={() => {
                      if (filter.key === 'selectedVaccinations') {
                        onClearSelection && onClearSelection();
                      } else {
                        removeFilter(filter);
                      }
                    }}
                  >
                    ✕
                  </button>
                </span>
              ))}
            </div>
            <div className="col-auto ms-auto ">
              {allActiveFilters.length > 0 && (
                <button 
                  className="btn btn-link text-primary"
                  onClick={clearAllFilters}
                >
                  Clear All
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VaccinationFiltersHeader;